import { createContext, useContext } from "react";
import { Menu } from "@/models";

export const MenusContext = createContext<Menu[] | null>(null);

export const useMenusContext = () => useContext(MenusContext);
